<template>
  <div
    class="play-btn-group"
    :class="{ 'play-btn-group--vertical': vertical }"
    role="group"
  >
    <slot />
  </div>
</template>

<script>
/**
 * PlayButtonGroup — joins adjacent buttons into one segmented control, merging
 * their borders and squaring the inner corners. Replaces bootstrap-vue's
 * <b-button-group>. Put <play-button>s (or any buttons) inside.
 */
export default {
  name: 'PlayButtonGroup',
  props: {
    vertical: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.play-btn-group {
  display: inline-flex;
  vertical-align: middle;

  /* square every inner corner, round only the outer ends */
  ::v-deep > * { border-radius: 0; }
  ::v-deep > *:first-child {
    border-top-left-radius: var(--radius);
    border-bottom-left-radius: var(--radius);
  }
  ::v-deep > *:last-child {
    border-top-right-radius: var(--radius);
    border-bottom-right-radius: var(--radius);
  }
  /* pull neighbours together so the shared edge is a single line */
  ::v-deep > * + * { margin-left: calc(-1 * var(--border-w)); }
  ::v-deep > *:hover,
  ::v-deep > *:focus-within { position: relative; z-index: 1; }

  &--vertical {
    flex-direction: column;

    ::v-deep > *:first-child {
      border-radius: var(--radius) var(--radius) 0 0;
    }
    ::v-deep > *:last-child {
      border-radius: 0 0 var(--radius) var(--radius);
    }
    ::v-deep > * + * {
      margin-left: 0;
      margin-top: calc(-1 * var(--border-w));
    }
  }
}
</style>
